import * as React from 'react';

import {Button} from 'shells/button/button';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {appHistory} from '../../../../../history';

import WeHaveLiftoffSVG from '../assets/we-have-liftoff.svg';
import {trackModalPageLoad} from '../track-page-load';

type Props = {
    onClose: () => void;
    currentUrl: string;
};

export function SmtpSuccess(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Great job! You’re all set up</ModalHeader>
                <ModalSubheader>
                    You can now send emails right from inside of Nutshell to specific contacts and
                    in bulk.
                </ModalSubheader>
                <div className='pad-16 flex align-center justify-center'>
                    <WeHaveLiftoffSVG />
                </div>
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    {/* We can't just use react-router links here, because we're inside a hashrouter. */}
                    <Button
                        variant='text'
                        onClick={() => appHistory.push('/my-account/email-sending')}
                    >
                        Review your settings
                    </Button>
                    <Button variant='primary' size='big' onClick={props.onClose}>
                        Close
                    </Button>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
